import PayeeState from "@/models/Accounts/Shared/Payees/PayeeState";

export default (payeeState: PayeeState) => {
    let returnVal = "Undefined";
    switch (payeeState) {
        case PayeeState.Active:
            returnVal = "Active"
            break;
        case PayeeState.Deleted:
            returnVal = "Deleted"
            break;
    }
    return returnVal;
}